module.exports = __webpack_public_path__ + "img/2015.79ef7646.svg";